export default __webpack_public_path__ + "static/media/photo--sm--13.756278bb.jpg";